import ADD_PRODUCT_CONTINENT from 'api/mutations/ADD_PRODUCT_CONTINENT';
import REMOVE_PRODUCT_CONTINENT from 'api/mutations/REMOVE_PRODUCT_CONTINENT';
import UPDATE_PRODUCT_CONTINENT from 'api/mutations/UPDATE_PRODUCT_CONTINENT';
import GET_PRODUCT_CONTINENTS from 'api/queries/GET_PRODUCT_CONTINENTS';
import { createProductParameterSlice } from './createProductParameterSlice';
const productContinentsSlice = createProductParameterSlice({
    name: 'productContinents',
    stateKey: 'productContinents',
    query: GET_PRODUCT_CONTINENTS,
    addMutation: ADD_PRODUCT_CONTINENT,
    updateMutation: UPDATE_PRODUCT_CONTINENT,
    removeMutation: REMOVE_PRODUCT_CONTINENT,
    idVariableName: 'productContinentId',
    selectConnection: (data) => data.autocomplete.productContinents,
    selectAddedItem: (data) => data.addProductContinent.productContinent,
    selectUpdatedItem: (data) => data.updateProductContinent.productContinent,
});
export const resetProductContinents = productContinentsSlice.reset;
export const fetchProductContinents = productContinentsSlice.fetchItems;
export const addProductContinent = productContinentsSlice.addItem;
export const updateProductContinent = productContinentsSlice.updateItem;
export const removeProductContinent = productContinentsSlice.removeItem;
export const selectProductContinents = productContinentsSlice.selectItems;
export const selectProductContinentById = productContinentsSlice.selectItemById;
export const selectProductContinentsPageInfo = productContinentsSlice.selectPageInfo;
export const selectProductContinentsStatus = productContinentsSlice.selectStatus;
export const selectProductContinentsErrors = productContinentsSlice.selectErrors;
export const selectProductContinentsRefetchFlags = productContinentsSlice.selectRefetchFlags;
export default productContinentsSlice.reducer;
